import { thor, MediaType, MediaGet } from "../../../typings/thor";

export class MediaGallerySidenavUploadMediaService {
    public static $inject: string[] = ["$log", "$q", "$translate", "imageService", "itemService", "uploadService"];

    private resource: thor.ItemGet = null;
    private mediaType: MediaType;
    private globalDeferred;

    private $t;
    private uploadedMedias: MediaGet[] = [];

    constructor(
        private $log: ng.ILogService,
        private $q: ng.IQService,
        $translate: ng.translate.ITranslateService,
        private imageService,
        private itemService,
        private uploadService
    ) {
        this.$t = $translate.instant;
    }

    public engine(resource: thor.ItemGet, files: File[]) {
        this.resource = resource;
        this.mediaType = MediaType.ItemPicture;
        this.globalDeferred = this.$q.defer();
        this.uploadedMedias = [];

        this.engineImages(files)
            .then(() => {
                this.globalDeferred.resolve();
                this.resource.medias.push(...this.uploadedMedias.sort((a, b) => a.rank - b.rank));
            })
            .catch(error => {
                this.globalDeferred.reject(error);
            });

        return this.globalDeferred.promise;
    }

    private notify(action, data) {
        this.globalDeferred.notify({action: action, data: data});
    }

    private engineImages(files: File[]) {
        const promises = [];
        files.forEach((file, index) => {
            const rank = this.resource.medias.length + index;
            promises.push(this.engineImage(file, rank));
        });

        return this.$q.all(promises);
    }

    private engineImage(file, rank) {
        const deferred = this.$q.defer();

        this.imageService
            .resizeImage(file)
            .then(blob => this.uploadImage(file.name, blob))
            .then(media => this.createResourceMedias(media, rank))
            .then(newMedia => {
                this.notify("incrementGauge", { key: "mediasCreated" });
                this.uploadedMedias.push(newMedia);
                (this.resource as thor.ItemGet).media_count = (this.resource as thor.ItemGet).media_count + 1;
                return deferred.resolve();
            })
            .catch(error => {
                this.$log.warn("Error while uploading an image (could be createResourceMedias)", error);
                this.notify("incrementGauge", { key: "mediasErrors" });
                // only a warning, keep process
                return deferred.resolve();
            });

        return deferred.promise;
    }

    private uploadImage(filename, blob) {
        const content = {
            type: this.mediaType,
            meta: {
                name: filename
            }
        };

        return this.uploadService
            .uploadFile(blob, content)
            .then(media => this.$q.resolve(media))
            .catch(error => {
                const errorMessage = error.status === 413
                    ? this.$t(
                        "fichier_n_a_pas_pu_etre_importe_la_taille_du_fichier_ne_doit_pas_exceder_n_mo",
                        { FILE: filename, N: 10 }
                    )
                    : this.$t("impossible_d_uploader_l_image", { FILE: filename });

                this.$log.error("Error while upload images", error);
                this.notify("addReportError", errorMessage);
                return this.$q.reject(error);
            });
    }

    private createResourceMedias(media, rank) {
        const body = {
            media_id: media.id,
            type: this.mediaType,
            rank
        };

        return this.itemService
            .createMedia(this.resource.id, body)
            .then(itemMedia => {
                const newMedia = {
                    id: media.id,
                    meta: itemMedia.meta,
                    rank: itemMedia.rank,
                    url: media.url,
                    name: media.meta.name,
                    md5sum: media.md5sum
                };
                this.$log.info(`Resource media created "${this.mediaType}":`, itemMedia);
                return this.$q.resolve(newMedia);
            })
            .catch(error => {
                this.$log.error(`Error while created resource media "${this.mediaType}"`, error);

                const reportError = this.$t("impossible_de_lier_le_lot_et_le_media", [this.resource.id, media.id]);
                this.notify("addReportError", reportError);

                return this.$q.reject(error);
            });
    }
}
